module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACwSURBVHgBtZJhDcJADIUfyQRMQiVMwknAAcPBHOwcMAmgABwQFCABHBAUwGsoyf3YljXpvuTLklv37tYr4ONKDwhE6MMUBCFrhNZ0oC/aIZBMP7RHIC1+Jz3TejNSkOgOvv6I+ayKxea/C73QG5Yj9jyVYXrswQI96FxqH7syXUcgw4fQu32byhetLXrDJmdRd/HM0hbFrY4V6P8nLKO3+jxVUMHHm+7pca5I+9AgiC/QJiRh24im7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share.png
// module id = 7/E+
// module chunks = 1